import { useState } from 'react'

import type { IntradayBidRow } from '~/pages/IntradayBidding/models/intradayBidRow'

export type IntradayDeleteConfirm = {
  target: IntradayBidRow | undefined
  open: (row: IntradayBidRow) => void
  close: () => void
  closeIfStill: (id: string) => void
}

/** 下書き削除確認の開閉状態。 */
export const useIntradayDeleteConfirm = (): IntradayDeleteConfirm => {
  const [target, setTarget] = useState<IntradayBidRow>()
  return {
    target,
    open: setTarget,
    close: () => setTarget(undefined),
    closeIfStill: (id) =>
      setTarget((current) => (current?.id === id ? undefined : current)),
  }
}
